module.exports = ".btn {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.tableRow:not(.tableHeaderRow) div {\r\n    line-height: 32px;\r\n}"